import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
    ApplicationConfig,
    importProvidersFrom,
    inject,
    LOCALE_ID,
    provideAppInitializer,
    provideEnvironmentInitializer,
} from '@angular/core';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { ApiGenModule } from '@api-gen/api-gen.module';
import { ApiRoamingModule } from '@api-roaming/api-roaming.module';
import { ClientApiInterceptor } from '@api/services/client-api-interceptor.service';
import { ErrorInterceptor } from '@api/services/error-interceptor.service';
import { LocaleService } from '@core/localization/locale.service';
import { defaultLocalizationConfig, LOCALIZATION_CONFIG } from '@core/localization/localization.config';
import { RouteTitleService } from '@core/router/route-title.service';
import { CurrencyInitService } from '@core/services';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from '@root/app.routes';
import { SharedModule } from '@shared/shared.module';
import { IMaskModule } from 'angular-imask';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';


export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        ApiGenModule,
        ApiRoamingModule,
        provideHttpClient(withInterceptorsFromDi()),
        provideEnvironmentInitializer(() => {
            inject(RouteTitleService);
        }),
        provideRouter(routes),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: '/i18n/',
                suffix: '.json',
            }),
        }),
        [
            { provide: LOCALIZATION_CONFIG, useValue: defaultLocalizationConfig },
            { provide: LOCALE_ID, useValue: LocaleService.getLocaleLang() },
        ],
        [
            {
                provide: RECAPTCHA_V3_SITE_KEY,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                useValue: (window as any).appSettings.APP_SETTINGS_RECAPTCHA_KEY,
            },
        ],
        provideDateFnsAdapter(),
        IMaskModule,
        importProvidersFrom(RecaptchaV3Module),
        importProvidersFrom(SharedModule),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ClientApiInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
        CurrencyInitService,
        provideAppInitializer(() => inject(CurrencyInitService).init()),
    ],
};
